// extracted by mini-css-extract-plugin
module.exports = {"greenBg":"Common_greenBg__1Qhk1","orangBg":"Common_orangBg__3hJ7n","redBg":"Common_redBg__2KKD8","greyBg":"Common_greyBg__3dLgx","tag":"Common_tag__1FDb6"};